"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.branch.list': 'Branże',
    'route.branch.create': 'Dodaj branżę',
    'route.branch.edit': 'Edytuj branżę',
};
